import {
    RESERVATION_EXPORT,
    RESERVATION_EXPORT_FAILURE,
    RESERVATION_EXPORT_SUCCESS,
} from 'store/actions/types';

export const exportReservation = (params) => {
    return {
        type: RESERVATION_EXPORT,
        params: params,
    };
};

export const exportReservationFailure = (error) => {
    return {
        type: RESERVATION_EXPORT_FAILURE,
        error: error,
    };
};

export const exportReservationSuccess = (payload) => {
    return {
        type: RESERVATION_EXPORT_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/reservations/exportReservations.js